import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, Tooltip } from 'components';
import { NewsService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import moment from 'moment';
import { EditIcon, TrashIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
	onEdit?: any;
	onDelete?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		item: this.props.item
	}
	
	render() {
		const item: any = this.state.item;

		return (
			<div id="modal-view-news">
				<div className="row">
					<div className="col-md-6">
						<p className="date">{ moment(item?.created_at).format('DD/MM/YYYY') }</p>
					</div>
					<div className="col-md-6 text-right">
						{
							checkPermission(Constants.MODULES.NEWS,'delete') && (
								<Tooltip title="Editar">
									<a className="link-icon" href="#" onClick={ (e: any) => this.props.onEdit(e,item) }>
										<img src={ EditIcon } />
									</a>
								</Tooltip>
							)
						}
						{
							checkPermission(Constants.MODULES.NEWS,'delete') && (
								<Tooltip title="Editar">
									<a className="link-icon" href="#" onClick={ (e: any) => this.props.onDelete(e,item) }>
										<img src={ TrashIcon } />
									</a>
								</Tooltip>
							)
						}
					</div>
				</div>
				<img src={ Constants.BASE_STORAGE + item?.image } className="image" />
				<p className="content">{ item?.text }</p>
			</div>
		)
	}
}

export default ModalView;